import React, { useState, useEffect } from 'react';
import Fnc from '../library/Functions'
import Loader from "react-loader-spinner";
import './DefInp.css';

function DefInp(props) {

  const [loading, setLoading] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);


  //const [, updateState] = React.useState();
  //const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    // Similar to componentDidMount and componentDidUpdate:

  }, [props.forceDisabled]); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

  function onBlur(e) {
    let val = e.target.value;

    setLoading(true);

    if (props.required) {

      if (val && val.length > 0) {
        //non ho un valore vuoto
        props.callback(new Fnc.Ret(Fnc.EnmGen.OK, val));
        setShowError(false);
        setErrorMsg(null);
      } else {
        setShowError(true);
        setErrorMsg(Fnc.EnmGen.EMPTY.msg);
        props.callback(new Fnc.Ret(Fnc.EnmGen.EMPTY));
      }

    } else {
      props.callback(new Fnc.Ret(Fnc.EnmGen.OK, val));
      setShowError(false);
      setErrorMsg(null);
    }

    setLoading(false);

}
  return (
    <>
      <input
			className={`form-control ${(props.forceDisabled === true) && "disabled"} `} 
			disabled={props.forceDisabled} 
			type="text"
			id={props.id} 
			placeholder="c " 
			key={props.value} 
			defaultValue={props.value} 
			onBlur={onBlur} 
			autoComplete="on"
			/>
      <span 
			className={`placeholder-text ${showError && "lblError"} ${(props.forceDisabled === true) && "disabled"}`}>{(props.required ? "* " : "") + props.label} 
			<Loader 
			visible={loading} 
			className="loadingSpinner" 
			type={Fnc.LoadingInp.TYPE} 
			color={Fnc.LoadingInp.COLOR} 
			height={Fnc.LoadingInp.HEIGHT} 
			width={Fnc.LoadingInp.WIDTH} 
			timeout={Fnc.LoadingInp.TIMEOUT}
			/>
			</span>
      {showError && <div className="iol-error-label">{errorMsg}</div>}
    </>
  );
}

export default DefInp;
